function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-around;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import WeatherContainer from './WeatherContainer';
import Flakes from './Flakes';
var SnowingContainer = styled(WeatherContainer)(_templateObject());

var Snowing = function Snowing() {
  return /*#__PURE__*/React.createElement(SnowingContainer, null, /*#__PURE__*/React.createElement(Flakes, null), /*#__PURE__*/React.createElement(Flakes, null));
};

export default Snowing;